import { getActiveFilter } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { TableName } from '../../../tables'
import { useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { Check } from '../state/types'

export const useCheckLoaders = () => {
    const systemHooks = useSystemStateHooks()

    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const loadAllChecks = async (active = false) => {
            const { loadMultiple } = loaders(companyId)
            const options = active ? getActiveFilter() : undefined
            const response = await loadMultiple(TableName.CHECKS, options)
            return response.dataTypes as Check[]
        }

        const loadCheck = (id: string, dbRequest = false) => {
            const { load } = loaders(companyId)
            return load(TableName.CHECKS, id, dbRequest) as Promise<O<Check>>
        }

        const loadChecks = (ids: string[]) => {
            const { loadByIds } = loaders(companyId)
            return loadByIds(TableName.CHECKS, ids) as Promise<Check[]>
        }
        
        return {
            loadAllChecks,
            loadCheck,
            loadChecks
        }
    }
}
